var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeaderboardSidebarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 68,
    viewBox: "0 0 93 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3472_7893)",
    filter: "url(#filter0_d_3472_7893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.7113 0L9.45312 35.9307H37.9748L23.7113 0Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2387 0L42.9805 35.9307H71.4969L57.2387 0Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M23.7113 0L9.45312 35.9307H37.9748L23.7113 0Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M57.2387 0L42.9805 35.9307H71.4969L57.2387 0Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0521 54.9539H1.95029C1.39094 54.9539 0.9375 55.4119 0.9375 55.977C0.9375 56.542 1.39094 57 1.95029 57H78.0521C78.6114 57 79.0649 56.542 79.0649 55.977C79.0649 55.4119 78.6114 54.9539 78.0521 54.9539Z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M78.0521 54.9539H1.95029C1.39094 54.9539 0.9375 55.4119 0.9375 55.977C0.9375 56.542 1.39094 57 1.95029 57H78.0521C78.6114 57 79.0649 56.542 79.0649 55.977C79.0649 55.4119 78.6114 54.9539 78.0521 54.9539Z",
    fill: "url(#paint0_radial_3472_7893)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3472_7893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.786 0L26.1932 21.0693C24.4103 23.4725 20.8444 23.4778 19.0615 21.0693L3.51091 0.0959148C3.51091 0.0959148 16.0442 53.2327 3.51091 53.2327C-9.02239 53.2327 15.9915 53.2327 15.9915 53.2327H67.5753C67.5753 53.2327 86.9871 53.2327 77.2812 53.2327C67.5753 53.2327 77.2812 0.0959148 77.2812 0.0959148L63.2234 20.5524C61.451 23.1314 57.6794 23.1314 55.9071 20.5524C50.7007 12.9805 41.786 0 41.786 0Z",
    fill: "#808080"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.786 0L26.1932 21.0693C24.4103 23.4725 20.8444 23.4778 19.0615 21.0693L3.51091 0.0959148C3.51091 0.0959148 16.0442 53.2327 3.51091 53.2327C-9.02239 53.2327 15.9915 53.2327 15.9915 53.2327H67.5753C67.5753 53.2327 86.9871 53.2327 77.2812 53.2327C67.5753 53.2327 77.2812 0.0959148 77.2812 0.0959148L63.2234 20.5524C61.451 23.1314 57.6794 23.1314 55.9071 20.5524C50.7007 12.9805 41.786 0 41.786 0Z",
    fill: "url(#paint1_radial_3472_7893)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3472_7893",
    x: 0,
    y: 0,
    width: 93,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3472_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3472_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3472_7893",
    x: -0.00390625,
    y: 0,
    width: 93.0039,
    height: 64.2327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 9,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3472_7893"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3472_7893",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3472_7893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.8887 56.0089) scale(22.6085 22.8384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3472_7893",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9978 26.6163) scale(33.8705 34.2149)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3978C",
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3472_7893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 57,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardSidebarIcon);
export default __webpack_public_path__ + "static/media/leaderboard_sidebar_icon.a5f398e7b7ffc9bdcc87162338c946b4.svg";
export { ForwardRef as ReactComponent };